export default function SmartphoneIcon() {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="6" y="2" width="20" height="28" rx="2" stroke="currentColor" strokeWidth="1.5" />
      <circle cx="16" cy="26" r="1.5" fill="currentColor" />
    </svg>
  );
}
